import * as types from '../../../lib/actionTypes.es6';

export var getOrgEmailTemplatesRequest = function(organizationGuid) {
  return { type: types.GET_ORG_EMAIL_TEMPLATES_REQUEST, payload: organizationGuid };
};
export var getOrgEmailTemplatesSuccess = function(payload) {
  return { type: types.GET_ORG_EMAIL_TEMPLATES_SUCCESS, payload: payload };
};
export var getOrgEmailTemplatesFailure = function(error) {
  return { type: types.GET_ORG_EMAIL_TEMPLATES_FAILURE, payload: error };
};

export var createOrgEmailTemplateRequest = function(payload) {
  return { type: types.CREATE_ORG_EMAIL_TEMPLATE_REQUEST, payload: payload };
};
export var createOrgEmailTemplateSuccess = function(payload) {
  return { type: types.CREATE_ORG_EMAIL_TEMPLATE_SUCCESS, payload: payload };
};
export var createOrgEmailTemplateFailure = function(error) {
  return { type: types.CREATE_ORG_EMAIL_TEMPLATE_FAILURE, payload: error };
};
export var resetCreateOrgEmailTemplateSuccess = function() {
  return { type: types.RESET_CREATE_ORG_EMAIL_TEMPLATE_SUCCESS };
};
export var resetCreateOrgEmailTemplateError = function() {
  return { type: types.RESET_CREATE_ORG_EMAIL_TEMPLATE_ERROR };
};

export var updateOrgEmailTemplateRequest = function(payload) {
  return { type: types.UPDATE_ORG_EMAIL_TEMPLATE_REQUEST, payload: payload };
};
export var updateOrgEmailTemplateSuccess = function(payload) {
  return { type: types.UPDATE_ORG_EMAIL_TEMPLATE_SUCCESS, payload: payload };
};
export var updateOrgEmailTemplateFailure = function(error) {
  return { type: types.UPDATE_ORG_EMAIL_TEMPLATE_FAILURE, payload: error };
};
export var resetUpdateOrgEmailTemplateSuccess = function() {
  return { type: types.RESET_UPDATE_ORG_EMAIL_TEMPLATE_SUCCESS };
};
export var resetUpdateOrgEmailTemplateError = function() {
  return { type: types.RESET_UPDATE_ORG_EMAIL_TEMPLATE_ERROR };
};

export var deleteOrgEmailTemplateRequest = function(payload) {
  return { type: types.DELETE_ORG_EMAIL_TEMPLATE_REQUEST, payload: payload };
};
export var deleteOrgEmailTemplateSuccess = function(payload) {
  return { type: types.DELETE_ORG_EMAIL_TEMPLATE_SUCCESS, payload: payload };
};
export var deleteOrgEmailTemplateFailure = function(error) {
  return { type: types.DELETE_ORG_EMAIL_TEMPLATE_FAILURE, payload: error };
};
export var resetDeleteOrgEmailTemplateSuccess = function() {
  return { type: types.RESET_DELETE_ORG_EMAIL_TEMPLATE_SUCCESS };
};
export var resetDeleteOrgEmailTemplateError = function() {
  return { type: types.RESET_DELETE_ORG_EMAIL_TEMPLATE_ERROR };
};
